import { ElMessageBox } from 'element-plus'

// 新版本更新提醒：
// 构建时 vite 往产物根目录写 version.json，并把同一版本号通过 define 编进 bundle（__APP_VERSION__）。
// 运行时每 10 分钟兜底轮询一次 version.json，与 __APP_VERSION__ 不一致即弹窗提示刷新；
// 标签页切回可见时立即检查一次（主力检测路径，发版后用户切回页面即感知）。

const VERSION_POLL_INTERVAL = 10 * 60 * 1000

// 「取消」过的版本号：同一版本不再重复弹。无需持久化——刷新后加载的已是新版本，出下一个新版本再弹
let dismissedVersion = ''
// 弹窗单例：已弹着时轮询继续但不再叠加弹第二个
let dialogShowing = false

/**
 * 弹「发现新版本」确认框：强制刷新 → 立即 reload；取消（含右上角 X）→ 记住该版本号本次不再弹。
 * version 传空表示无版本号场景（如 chunk 加载失败兜底），取消后仅关闭本次，下次触发仍会弹。
 */
export const showVersionUpdateConfirm = (message: string, version = '') => {
  if (dialogShowing) return
  if (version && version === dismissedVersion) return
  dialogShowing = true
  ElMessageBox.confirm(message, '发现新版本', {
    type: 'warning',
    confirmButtonText: '强制刷新',
    cancelButtonText: '取消',
    closeOnClickModal: false
  })
    .then(() => {
      window.location.reload()
    })
    .catch(() => {
      // 取消 / 右上角 X 同语义：该版本本次会话不再提醒
      if (version) {
        dismissedVersion = version
      }
    })
    .finally(() => {
      dialogShowing = false
    })
}

/**
 * 启动新版本轮询检测（App.vue 挂载时调用一次），仅生产构建生效。
 * 请求失败 / 404 / 非 JSON 一律静默忽略，下一轮再试。
 */
export const useVersionCheck = () => {
  if (!import.meta.env.PROD) return

  const checkVersion = async () => {
    try {
      // base 可能是环境相关子路径，必须用 BASE_URL 拼；加时间戳 + no-store 防缓存
      const res = await fetch(`${import.meta.env.BASE_URL}version.json?t=${Date.now()}`, {
        cache: 'no-store'
      })
      if (!res.ok) return
      const data = await res.json()
      const remoteVersion = typeof data?.version === 'string' ? data.version : ''
      if (!remoteVersion || remoteVersion === __APP_VERSION__) return
      showVersionUpdateConfirm(
        '后台已发布新版本，刷新后生效。未保存的编辑内容刷新后会丢失。',
        remoteVersion
      )
    } catch {
      // 网络异常 / 响应非 JSON：静默忽略，下一轮再试
    }
  }

  setInterval(checkVersion, VERSION_POLL_INTERVAL)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      checkVersion()
    }
  })
}
